import { emptyObject } from 'ui-components/default-props/empty';
import { BEGIN_OPTIMISTIC_UPDATE, COMMIT_OPTIMISTIC_UPDATE, REVERT_OPTIMISTIC_UPDATE } from '../optimistic.update.reducer';
import { GuidService } from 'ui-components/services/guid-service';

export const ENTITIES_LOAD = 'ENTITIES_LOAD';
export const entitiesLoad = (normalizedPayload) => ({
  type: ENTITIES_LOAD,
  entities: normalizedPayload?.entities ?? emptyObject,
});

export const INVENTORY_ENTITIES_LOAD = 'INVENTORY_ENTITIES_LOAD';
export const inventoryEntitiesLoad = (normalizedPayload) => ({
  type: INVENTORY_ENTITIES_LOAD,
  entities: normalizedPayload?.entities ?? emptyObject,
});

export const ENTITIES_PATCH_RATES = 'ENTITIES_PATCH_RATES';
export const entitiesPatchRates = (fulfillmentPlanId, ratePayload, propertiesPayload) => ({
  type: ENTITIES_PATCH_RATES,
  fulfillmentPlanId,
  ratePayload,
  propertiesPayload,
});

export const ENTITIES_PATCH_CUSTOMS = 'ENTITIES_PATCH_CUSTOMS';
export const entitiesPatchCustoms = (fulfillmentPlanId, customsPayload) => ({
  type: ENTITIES_PATCH_CUSTOMS,
  fulfillmentPlanId,
  customsPayload,
});

export const BULK_LOAD_ENTITIES_REQUEST = 'BULK_LOAD_ENTITIES_REQUEST';
export const bulkRequestEntities = ({ salesOrderIds }) => {
  return {
    type: BULK_LOAD_ENTITIES_REQUEST,
    payload: { salesOrderIds },
  };
};

export const BULK_LOAD_ENTITIES_SUCCESS = 'BULK_LOAD_ENTITIES_SUCCESS';
export const bulkRequestEntitiesSuccess = ({ salesOrderIds }) => {
  return {
    type: BULK_LOAD_ENTITIES_SUCCESS,
    salesOrderIds,
  };
};

export const SAVE_BULK_REQUEST_METADATA = 'SAVE_BULK_REQUEST_METADATA';
export const saveBulkRequestMetadata = ({ requestId, requestTime }) => {
  return {
    type: SAVE_BULK_REQUEST_METADATA,
    requestId,
    requestTime,
  };
};

export const OPTIMISTICALLY_PATCH_SALES_ORDER_ENTITY = 'OPTIMISTICALLY_PATCH_SALES_ORDER_ENTITY';
export const updateSalesOrderEntityOptimistically = (salesOrderId, newSalesOrder) => ({
  type: OPTIMISTICALLY_PATCH_SALES_ORDER_ENTITY,
  salesOrderId,
  newSalesOrder,
});

export const OPTIMISTICALLY_PATCH_FULFILLMENT_PLAN_ENTITIES = 'OPTIMISTICALLY_PATCH_FULFILLMENT_PLAN_ENTITIES';
export const updateFulfillmentPlanEntitiesOptimistically = (fulfillmentPlanIds, newFulfillmentPlans) => ({
  type: OPTIMISTICALLY_PATCH_FULFILLMENT_PLAN_ENTITIES,
  fulfillmentPlanIds,
  newFulfillmentPlans,
});

export const ENTITIES_BULKLOAD = 'ENTITIES_BULKLOAD';
export const entitiesBulkload = (entities) => ({
  type: ENTITIES_BULKLOAD,
  entities,
});

export const UPDATE_FULFILLMENT_PLAN_NOTE_REQUEST = 'UPDATE_FULFILLMENT_PLAN_NOTE_REQUEST';
export const UPDATE_FULFILLMENT_PLAN_NOTE_SUCCESS = 'UPDATE_FULFILLMENT_PLAN_NOTE_SUCCESS';
export const UPDATE_FULFILLMENT_PLAN_NOTE_FAILURE = 'UPDATE_FULFILLMENT_PLAN_NOTE_FAILURE';
export const updateFulfillmentPlanNoteRequest = ({ fulfillmentPlanId, note }) => {
  const optimisticId = GuidService.newGuid();
  return {
    type: UPDATE_FULFILLMENT_PLAN_NOTE_REQUEST,
    payload: { fulfillmentPlanId, note },
    meta: {
      optimistic: BEGIN_OPTIMISTIC_UPDATE,
      optimisticId,
      onSuccess: () => ({
        type: UPDATE_FULFILLMENT_PLAN_NOTE_SUCCESS,
        meta: {
          optimistic: COMMIT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
      onError: (error) => ({
        type: UPDATE_FULFILLMENT_PLAN_NOTE_FAILURE,
        payload: new Error(error),
        error: true,
        meta: {
          optimistic: REVERT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
    },
  };
};

export const UNLOCK_ADDRESS_REQUEST = 'UNLOCK_ADDRESS_REQUEST';
export const UNLOCK_ADDRESS_SUCCESS = 'UNLOCK_ADDRESS_SUCCESS';
export const UNLOCK_ADDRESS_FAILURE = 'UNLOCK_ADDRESS_FAILURE';
export const unlockAddressRequest = (fulfillmentPlanIds) => {
  const optimisticId = GuidService.newGuid();
  return {
    type: UNLOCK_ADDRESS_REQUEST,
    payload: { fulfillmentPlanIds },
    meta: {
      optimistic: BEGIN_OPTIMISTIC_UPDATE,
      optimisticId,
      onSuccess: () => ({
        type: UNLOCK_ADDRESS_SUCCESS,
        meta: {
          optimistic: COMMIT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
      onError: () => ({
        type: UNLOCK_ADDRESS_FAILURE,
        meta: {
          optimistic: REVERT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
    },
  };
};

export const UPDATE_FULFILLMENT_PLAN_ADDITIONAL_OPTIONS = 'UPDATE_FULFILLMENT_PLAN_ADDITIONAL_OPTIONS';
export const updateFulfillmentPlanAdditionalOptions = (fulfillmentPlanId, additionalOptions) => ({
  type: UPDATE_FULFILLMENT_PLAN_ADDITIONAL_OPTIONS,
  fulfillmentPlanId,
  additionalOptions,
});

export const ENTITIES_START_SALES_ORDER_LOADING = 'ENTITIES_START_SALES_ORDER_LOADING';
export const startSalesOrderLoading = (salesOrderIds) => ({
  type: ENTITIES_START_SALES_ORDER_LOADING,
  salesOrderIds,
});

export const ENTITIES_PATCH_ALTERNATIVE_RATES = 'ENTITIES_PATCH_ALTERNATIVE_RATES';
export const entitiesPatchAlternativeRates = (alternativeRatesPayload) => ({
  type: ENTITIES_PATCH_ALTERNATIVE_RATES,
  alternativeRatesPayload,
});

export const DISMISS_FRAUD_INDICATOR_REQUEST = 'DISMISS_FRAUD_INDICATOR_REQUEST';
export const DISMISS_FRAUD_INDICATOR_SUCCESS = 'DISMISS_FRAUD_INDICATOR_SUCCESS';
export const DISMISS_FRAUD_INDICATOR_FAILURE = 'DISMISS_FRAUD_INDICATOR_FAILURE';
export const dismissFraudIndicatorRequest = (fulfillmentPlanId, fraudIndicatorCode, indicator) => {
  const optimisticId = GuidService.newGuid();
  return {
    type: DISMISS_FRAUD_INDICATOR_REQUEST,
    payload: { fulfillmentPlanId, fraudIndicatorCode, indicator },
    meta: {
      optimistic: BEGIN_OPTIMISTIC_UPDATE,
      optimisticId,
      onSuccess: () => ({
        type: DISMISS_FRAUD_INDICATOR_SUCCESS,
        payload: { fulfillmentPlanId, fraudIndicatorCode, indicator },
        meta: {
          optimistic: COMMIT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
      onError: (error) => ({
        type: DISMISS_FRAUD_INDICATOR_FAILURE,
        payload: { fulfillmentPlanId, fraudIndicatorCode, error },
        error: true,
        meta: {
          optimistic: REVERT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
    },
  };
};
